export enum AuthRoutesPaths {
  Login = '/login',

  Guest = '/guest',

  Registration = '/registration',
  RegistrationFigmaLogin = '/registration/figma_login',
  RegistrationAccountCreated = '/registration/account_created',

  ForgotPassword = '/forgot_password',
  ResetPassword = '/reset_password',
  AcceptInvitation = '/accept_invitation',

  GoogleAuth = '/auth/google',

  FigmaAuth = '/auth/figma',

  Auth = '/auth/:type',
  AuthSuccess = '/auth/:type/success',
  AuthFailure = '/auth/:type/failure',
}
